module fdm {

    angular.module('fdm', [
        'ngAnimate',
        'ngCookies',
        'ngStorage',
        //'pascalprecht.translate',
        'ui.router',
        'ui.bootstrap',
        // 'AdalAngular',//'dgAuth', //using adal instead
        'MsalAngular',
        'ngSanitize',
        'toaster',
        'angular.filter',
        'base64',
        'dg',
        'dg.modules.users',
        'dg.restfulApi',
        //'dgComponents',
        //'dgComponents.list',
        //'dgComponents.files.dgFlow',
        //'dgComponents.files',
        // 'dgMetadata',
        'fdm.templates',
        'fdm.common',
        'fdm.flightLegs',
        'fdm.flightEvents',
        'fdm.performedLegs',
        'fdm.pilotPerformance',
        'fdm.general',
        'fdm.aircrafts',
        'fdm.rawFiles',
        'fdm.flightSegment',
        'fdm.clientManagement',
    ])
        //rootScope configuration
        .run(($rootScope: IAppRootScopeService, $q: ng.IQService, $state: ng.ui.IStateService,
            $stateParams: ng.ui.IStateParamsService,
            applicationInfoService: dg.clients.ApplicationInfoService,
            $transitions: any, msalAuthenticationService, $window,
            restfullApiClientService: dg.restfulApi.RestfullApiClientService) => {

            // Allows to retrieve UI Router state information from inside templates
            $rootScope.$state = $state;
            $rootScope.$stateParams = $stateParams;

            $rootScope.$on("msal:loginFailure", (s) => {
                msalAuthenticationService.logout();
            });

            $rootScope.$on("msal:acquireTokenFailure", (s) => {
                msalAuthenticationService.logout();
            });

            $rootScope.$on("msal:acquireTokenSuccess", (s) => {

            });

            $rootScope.$on("msal:loginSuccess", (s) => {
                if (!$rootScope.userInfo.isAuthenticated) {
                    msalAuthenticationService.logout();
                }
            });

            $rootScope.$on("adal:errorResponse", (s) => {
                //if (!$rootScope.userInfo.isAuthenticated) {
                //    msalAuthenticationService.logout();
                //}
            });

            $rootScope.$on("msal:notAuthorized", (s) => {
                // msalAuthenticationService.logout();
            });

            $rootScope.$on("adal:loginRedirect", (s) => {

            });

            $transitions.onBefore({}, ($transition$) => {

                if (!$rootScope.userInfo.isAuthenticated) {
                    if (!msalAuthenticationService.loginInProgress()) {
                        msalAuthenticationService.loginRedirect();
                    }

                } else if ($rootScope.userInfo.isAuthenticated) {
                    return applicationInfoService.ensureInitialized();
                }

            });

            $transitions.onError({}, transition => {
                if (transition.error().type == 6) {

                    let code = transition.error().detail.status;

                    if (code && code != -1) {

                        // Uncomment if no internet connection page handling is desired (Currently handled with popup)

                        //if (code == -1 && !restfullApiClientService.hostReachable()) {
                        //    $state.go('no-connection');
                        //}
                        //else {
                        $state.go('error-handler', { errorCode: code });
                        //}
                    }
                }
            });

            $transitions.onStart({}, ($transition$) => {
                //$rootScope.stateIsLoading = true;
            });

            $transitions.onBefore({ to: 'app' }, ($transition$) => {
                //let substate = $transition$.to().defaultSubstate;
                if ($rootScope.userInfo.isAuthenticated) {
                    const currentUser = applicationInfoService.getCurrentUser();
                    const isPilot = currentUser && currentUser.isPilot;
                    
                    if(isPilot) {
                        return $transition$.router.stateService.target('app.pilotSelfOverview');
                    } else {
                        return $transition$.router.stateService.target('app.aircrafts');
                    }
                    
                }
            });

            //Restangular.setErrorInterceptor((resp: Restangular.IResponse) => {
            //    if (resp.status == 401) {
            //        adalAuthenticationService.logOut();
            //        return false;
            //    } else if (resp.status == 403) {
            //        adalAuthenticationService.logOut();
            //        //TODO: redirect to state 403 when the server is not returning 403 got html pages
            //        //$state.go('error403');
            //        return false;
            //    }
            //    return true;
            //});
        });
}